import { UNCUBES_SERVER_TOKEN_ENDPOINT } from '@dynameat/constants';
import axios from 'axios';

export const uncubesServerTokenRequest = () => axios.get(UNCUBES_SERVER_TOKEN_ENDPOINT());
